<template>
  <UCard class="rounded-none md:rounded-lg border-b">
    <div class="space-y-4">
      <!-- Sipariş Başlık -->
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <p class="text-sm text-gray-700 font-medium">
            Sipariş No: <span class="font-bold">#{{ order.id }}</span>
          </p>
          <p class="text-sm text-gray-500 flex items-center gap-1">
            <UIcon name="i-heroicons-calendar" class="w-4 h-4" />
            {{ formatDate(order.created_at) }}
          </p>
        </div>
        <UBadge color="yellow" variant="soft" class="flex items-center gap-1">
          <UIcon name="i-heroicons-clock" class="w-4 h-4" />
          <span>Ödeme Bekleniyor</span>
        </UBadge>
      </div>

      <!-- Sipariş Ürünleri ve Toplam Tutar -->
      <div class="flex items-center justify-between">
        <FrontendOrderItemsSummary :items="order.items_summary" />
        <div class="text-right">
          <p class="text-sm text-gray-500 mb-0.5">Toplam Tutar</p>
          <p class="text-lg font-semibold">{{ formatPrice(order.total) }}</p>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <template #footer>
      <UButton :to="`/hesap/siparislerim/${order.id}`" variant="outline" color="orange" class="w-full">
        Sipariş Detayı
      </UButton>
    </template>
  </UCard>
</template>

<script setup>
const props = defineProps({
  order: {
    type: Object,
    required: true
  }
})

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('tr-TR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
}
</script>
